module.exports = __webpack_public_path__ + "static/media/20240401_144325.3e72e615.jpg";